<p-card>
    <ng-template pTemplate="header">
        <div class="pr-4 pl-4 pt-4">
            <div *ngIf="showBack" class="flex mb-3" (click)="goBack()">
                <p-button label="Back" icon="pi pi-arrow-left" [text]="true" [plain]="true" />
            </div>
            <div class="flex justify-content-between">
                <div><h3>Transactions</h3></div>
                <div class="flex">
                    <p-calendar [(ngModel)]="filter.startDate" 
                        (onSelect)="filterTableDirectly()" 
                        (onClear)="filterTableDirectly()" 
                        placeholder="From:" 
                        [showIcon]="true" 
                        dateFormat="dd/mm/yy"></p-calendar>
            
                    <p-calendar [(ngModel)]="filter.endDate" 
                        (onSelect)="filterTableDirectly()" 
                        (onClear)="filterTableDirectly()" 
                        placeholder="To:" 
                        [showIcon]="true" 
                        dateFormat="dd/mm/yy"></p-calendar>

                    <span class="p-input-icon-left mr-2">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="search-input"
                                [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                                placeholder="Search..." />
                    </span>
                    <p-button label="Export" icon="pi pi-download" (click)="openExportSidebar()" />
                </div>
            </div>
        </div>
    </ng-template>
    <p class="m-0">
        <p-table #xpressUsersGrid
                    [columns]="transactionsCols"
                    [value]="paymentTransactions"
                    [lazy]="true"
                    responsiveLayout="scroll" dataKey="Id"
                    (onLazyLoad)="handleLazyLoad($event)"
                    [showFirstLastIcon]="false"
                    [resizableColumns]="true"
                    [columnResizeMode]="'expand'"
                    [autoLayout]="true"
                    [styleClass]="'p-datatable-gridlines'"
                    [scrollable]="true"
                    [scrollHeight]="'flex'"
                    [paginator]="true"
                    [loading]="loading"
                    [(first)]="first"
                    [rows]="rowsPerPage"
                    [rowsPerPageOptions]="rowsPerPageOptions"
                    [totalRecords]="totalRecords">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of transactionsCols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="false"
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transaction>
                <tr> 
                    <td>
                        <span>{{transaction.TransactionId}}</span>
                    </td>
                    <td>
                        <span class="status" [ngStyle]="getStatusStyles(transaction.Status)">{{getStatusText(transaction.Status)}}</span>
                    </td>
                    <td>
                        <span>{{transaction.TransactionDate | date: 'MMM dd, yyyy'}}</span>
                    </td>
                    <td>
                        <span>{{transaction.StandardAging}}</span>
                    </td>
                    <td>
                        <span>{{transaction.ProductId}}</span>
                    </td>
                    <td>
                        <!-- <a class="cursor-pointer" target="_blank" (click)="getProductDetails(transaction.CommerceId)">{{transaction.ProductName}}</a> -->
                         <span>{{transaction.ProductName}}</span>
                    </td>
                    <td>
                        <span>{{transaction.AmountDeducted | currency: 'PHP' : 'symbol' : '1.2-2'}}</span>
                    </td>
                    <td>
                        <span>{{transaction.Frequency === 1 ? 'Daily' : transaction.Frequency === 2 ? 'Weekly' : 'Monthly'}}</span>
                    </td>
                    <td>
                        <span>{{transaction.DueDate | date: 'MMM dd, yyyy'}}</span>
                    </td>
                    <td>
                        <span>{{transaction.Balance | currency: 'PHP' : 'symbol' : '1.2-2'}}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template class="mt-3" pTemplate="paginatorleft" let-state>
                <div *ngIf="paymentTransactions.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + paymentTransactions.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </p>

    <!-- Remove because it causes style overlapping -->
    <!-- <div class="flex-row w-full" *ngIf="paymentTransactions.length < 1">
        <div class="col-12 text-center align-content-center h-30rem commerce-section">
            <img src="/XpressApp/assets/images/commerce/no-product.png" class="mb-1" />
            <div class="product-not-title">There are no existing product. Create one!</div>
        </div>
    </div> -->
</p-card>

<!-- Export Sidebar -->
<p-sidebar [(visible)]="showExportSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="changedVisibleExportSidebar(false)"
           [style]="{width:'580px'}">
    <ng-template pTemplate="header">Export data</ng-template>

    <div class="flex flex-column mt-2">
        <label class="export-data-label mb-2">File Type</label>
        <p-dropdown [options]="ExportFileTypeModel.ExportFileTypes" placeholder="Please Select" optionLabel="name" optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
    </div>
    <div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
        <button class="btn-darkblue" pButton label="Download" (click)="export()"></button>
    </div>
</p-sidebar>

<!-- Export Loading Dialog -->
<p-dialog
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [resizable]="false"
        [(visible)]="exportLoading"
        [style]="{ width: '425px', height: '215px' }">
    <ng-template pTemplate="header">
        <div class="text-center">Exporting...</div>
    </ng-template>
    <div class="text-center">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="4" fill="transparent" animationDuration=".5s"></p-progressSpinner>
        <p class="mt-3">Please wait while we prepare your file...</p>
    </div>
</p-dialog>